module.exports = __webpack_public_path__ + "img/fleteros.076cb06a.png";